import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaperIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	stroke: "#A0A0A0",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1668 6.66536V9.9987C15.1668 13.332 13.8335 14.6654 10.5002 14.6654H6.50016C3.16683 14.6654 1.8335 13.332 1.8335 9.9987V5.9987C1.8335 2.66536 3.16683 1.33203 6.50016 1.33203H9.8335",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1668 6.66536H12.5002C10.5002 6.66536 9.8335 5.9987 9.8335 3.9987V1.33203L15.1668 6.66536Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.1665 8.66797H9.1665",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.1665 11.332H7.83317",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPaperIcon;
